module.exports = __webpack_public_path__ + "static/media/Avatars_Female-25.4c00ff17.png";